var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.403 8H21.581C23.2251 8.006 31.5556 8.066 33.8018 8.67004C34.4808 8.85439 35.0996 9.21372 35.5962 9.71212C36.0928 10.2105 36.45 10.8305 36.6319 11.5102C36.834 12.2703 36.976 13.2763 37.072 14.3144L37.092 14.5224L37.136 15.0424L37.152 15.2505C37.282 17.0786 37.298 18.7907 37.3 19.1647V19.3147C37.298 19.7027 37.28 21.5308 37.136 23.435L37.12 23.645L37.102 23.853C37.002 24.9971 36.854 26.1331 36.6319 26.9692C36.4506 27.6491 36.0936 28.2694 35.5969 28.7679C35.1001 29.2664 34.4811 29.6256 33.8018 29.8094C31.4816 30.4334 22.6631 30.4774 21.441 30.4794H21.157C20.5389 30.4794 17.9828 30.4674 15.3026 30.3754L14.9626 30.3634L14.7886 30.3554L14.4466 30.3414L14.1045 30.3274C11.8844 30.2294 9.77027 30.0714 8.79621 29.8074C8.11714 29.6237 7.49826 29.2649 7.00154 28.7668C6.50483 28.2687 6.14773 27.6488 5.96603 26.9692C5.74402 26.1351 5.59601 24.9971 5.496 23.853L5.48 23.643L5.464 23.435C5.36529 22.0797 5.31059 20.7215 5.29999 19.3627L5.29999 19.1167C5.30399 18.6867 5.31999 17.2006 5.428 15.5605L5.442 15.3545L5.448 15.2505L5.464 15.0424L5.508 14.5224L5.528 14.3144C5.62401 13.2763 5.76602 12.2683 5.96803 11.5102C6.14943 10.8303 6.50639 10.21 7.00312 9.71147C7.49985 9.21298 8.1189 8.85384 8.79821 8.67004C9.77227 8.41003 11.8864 8.25002 14.1065 8.15001L14.4466 8.13601L14.7906 8.12401L14.9626 8.11801L15.3046 8.10401C17.2081 8.04275 19.1125 8.00875 21.017 8.002H21.403V8ZM18.1008 14.4204V24.057L26.4153 19.2407L18.1008 14.4204Z",
    fill: "url(#paint0_linear_1048_33689)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1048_33689",
    x1: 5.29999,
    y1: 19.3582,
    x2: 38.7562,
    y2: 19.3517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00394562,
    stopColor: "#F44554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3271E1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.9e5e57486fe86bc011ee04db8ae8721c.svg";
export { ForwardRef as ReactComponent };